const Notification = () =>
  import(
    /* webpackChunkName: "system-gateway-notification" */ '@/pages/system/gateway/notification/index.vue'
  )
const CreateNotification = () =>
  import(
    /* webpackChunkName: "system-gateway-notification" */ '@/pages/system/gateway/notification/create.vue'
  )
const EditNotification = () =>
  import(
    /* webpackChunkName: "system-gateway-notification" */ '@/pages/system/gateway/notification/edit.vue'
  )

export default {
  path: 'notification',
  meta: {
    label: 'notification',
    auth: 'notification'
  },
  component: {
    name: 'Notification',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: '',
      name: 'SystemGatewayNotification',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Notification
    },
    {
      name: 'SystemCreateGatewayNotification',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateNotification
    },
    {
      name: 'SystemEditGatewayNotification',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditNotification,
      props: true
    }
  ]
}
